
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/network/my-circle/second",
      function () {
        return require("private-next-pages/profile/network/my-circle/second/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/network/my-circle/second"])
      });
    }
  